<template>
	<div class="vipvipvip">
		<div class="show">
			<div class="show-title">
				<!-- <image src="/static/img/vip.png" mode=""></image> -->
				<span>开通VIP查看</span>
				<span>全部数据</span>
			</div>
			<div class="show-button" hover-class="hover" @click="navigatePay">立即开通VIP</div>
		</div>
	</div>
</template>

<script>
	import { EventBus } from '@/utils/event-bus.js';
	export default {
		name:"n-vip",
		props: {
			name: {
				type: [String],
				default: '隐藏数据'
			},
			version: {
				type: [String],
				default: '标准版'
			},
		},
		data() {
			return {
				// user:uni.getStorageSync('user')||'',//填报信息
				user:JSON.parse(localStorage.getItem('user'))||'',
				token: localStorage.getItem('token')||'',
			};
		},
		onShow(){
			this.user=JSON.parse(localStorage.getItem('user'))||''
			
		},
		methods:{
			//跳转支付
			navigatePay(){
				
				if(!localStorage.getItem('token')) {
					// 登录弹框
					EventBus.$emit('noopsycheOpen');
					return
				}
				
				if(!this.user.score) {
					// 个人信息弹框
					EventBus.$emit('showModal');
					return
				}
				EventBus.$emit('vipOpen');
				// uni.navigateTo({
				// 	url:`/indexModule/wxpay`
				// });
			},
		}
	}
</script>

<style lang="scss">
	.vipvipvip{
	 height: 100px;
    width: 50%;
	text-align: center;
	background:rgba(0, 0, 0, 0.1);
	border-radius: 10px;
	padding-bottom: 30px;
	}
	.show {
		padding: 15rpx 30px;
		font-size: 16px;
		position: absolute;
		left: 0;
		right: 0;
		z-index: 9;
	width: 50%;
		&-title {
			font-weight: 600;
			color: red;
			margin: 20px auto;
			image {
				width: 25px;
				height: 25px;
			}
	
			text:nth-last-child(1) {
				color: #E72F29;
			}
		}
	
		&-button {
			width: 90%;
			height: 40px;
			line-height: 40px;
			background: #E72F29;
			color: #fff;
			font-size: 17px;
			border-radius:8px;
			margin: 20px auto;
		}
	}
</style>
